"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventService = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * {@inheritDoc IEventService}
 */
class EventService {
    constructor() {
        this.categories = new WeakMap();
    }
    getCategory(category) {
        let broadcastEvent = this.categories.get(category);
        if (broadcastEvent == null) {
            broadcastEvent = new rc_js_util_1.BroadcastEvent(category.callbackKey);
            this.categories.set(category, broadcastEvent);
        }
        return broadcastEvent;
    }
}
exports.EventService = EventService;
//# sourceMappingURL=event-service.js.map